jQuery(window).on('elementor/frontend/init', (e) => {
  class WidgetHandlerClass extends elementorModules.frontend.handlers.Base {
    constructor(...args) {
      super(...args)

      jQuery('.onereach-accordion__header').each(function () {
        const text = this.nextElementSibling;
        if (text.classList.contains('max-height')) {
          text.classList.remove('max-height');
          const close = document.querySelector('.onereach-accordion').dataset.close;
          if (close === 'yes') {
            this.classList.remove('active')
            text.style.maxHeight = null;
          } else {
            text.style.maxHeight = text.scrollHeight + "px";
          }
        }
      });
    }

    getDefaultSettings() {
      return {
        selectors: {
          toggleButton: '.onereach-accordion__header',
          wrapper: '.onereach-accordion',
        },
      }
    }

    getDefaultElements() {
      const selectors = this.getSettings('selectors')
      return {
        $toggleButtons: this.$element.find(selectors.toggleButton),
      }
    }

    bindEvents() {
      this.elements.$toggleButtons.on('click', this.onButtonClick)
    }

    onButtonClick() {
      const text = this.nextElementSibling;

      if (text.style.maxHeight) {
        this.classList.remove('active')
        text.style.maxHeight = null;
      } else {
        this.classList.add('active')
        text.style.maxHeight = text.scrollHeight + "px";
      }
    }
  }

  elementorFrontend.hooks.addAction(
    'frontend/element_ready/onereach-accordion.default',
    ($element) => {
      elementorFrontend.elementsHandler.addHandler(WidgetHandlerClass, {
        $element,
      })
    }
  )
});